<template>
  <div class="rotating-icon">
    <i :class="['ti', `ti-${iconName}`, iconFont[size], `color-${color}`]"></i>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { ComponentSizeType } from "@/types/componentType";
import { ICON_FONT } from "@/constants/sizing";

export default defineComponent({
  name: "CustomRotatingIcon",
  props: {
    iconName: { type: String, default: "settings" },
    size: { type: String as PropType<ComponentSizeType>, default: "small" },
    color: { type: String, default: "medium" },
  },
  setup() {
    // Role D — shared icon-led font ladder (m/l/xl). Replaces the former
    // xs/m/l map that skipped a step between small and default.
    return { iconFont: ICON_FONT };
  },
});
</script>

<style lang="scss" scoped>
// scoped-defer: bucket-d-animation: animation consumer (animation)
.rotating-icon i {
  display: inline-block;
  animation: rotate 4s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
